import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	ViewChild,
} from "@angular/core";

@Component({
	selector: "app-question-attachment-modal",
	templateUrl: "./question-attachment-modal.component.html",
	styleUrls: ["./question-attachment-modal.component.css"],
})
export class QuestionAttachmentModalComponent implements OnInit {
	display: Boolean = false;
	question_attachments: any[];
	question_name: string;
	files;
	onHide: Function;
	@Output() save = new EventEmitter();
	constructor() { }

	ngOnInit() { }
	onSelect(e) {
		if (e.files)
			Array.from(e.files).forEach((item: Blob | any, i, arr) => {
				// console.log(item)
				const reader = new FileReader();
				reader.readAsDataURL(item);
				reader.onload = () => {
					let newAttachments = [...this.question_attachments];
					newAttachments.push({
						base64: reader.result,
						type: item.type.length > 0 ? item.type : item.name.split(".").pop(),
						name: item.name,
						size: item.size,
					});
					this.question_attachments = newAttachments;
					this.save.emit(this.question_attachments);
					// return res.result
					return;
				};
				if (arr.length - 1 === i) this.files = [];
			});
		//   this.question_attachments = [{type:"a", name:'b', size:"a"}]
		// this.files = e.files
	}
	deleteAttachment() {

		this.question_attachments = []
		this.files = null;
		this.save.emit([]);

	}
	onHideCallback() {
		this.files = null;
		this.onHide();
	}
	onConfirm() { }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/question-group/question/question-attachment-modal/question-attachment-modal.component.ts